/** Atmosfera institucional — pausa, espaço e rede. Sem catálogo de aparelhos. */
export const CIRCUITO_IMG = {
  hero: '/images/circuito/hero-pausa.png',
  servidora: '/images/circuito/servidora-pausa.png',
  montagem: '/images/circuito/montagem-unidade.png',
  rede: '/images/circuito/rede-cidade.png',
  educacao: '/images/circuito/educacao-pausa.png',
  assistencia: '/images/circuito/assistencia-pausa.png',
} as const;
